import { type ComponentProps, forwardRef, memo } from 'react';

import { cn } from '@air/utils-tailwind';

export type TreeItemButtonProps = ComponentProps<'button'>;

export const TreeItemButton = memo(
  forwardRef<HTMLButtonElement, TreeItemButtonProps>(({ className, children, ...restOfProps }, forwardedRef) => {
    return (
      <button
        className={cn(
          'flex h-full w-full min-w-0 items-center justify-start border-box text-14 after:absolute after:inset-0 after:-z-1 after:h-full after:w-full after:content-[""] disabled:cursor-not-allowed disabled:opacity-45',
          className,
        )}
        data-testid="TREE_ITEM_BUTTON"
        ref={forwardedRef}
        type="button"
        {...restOfProps}
      >
        <span className="truncate">{children}</span>
      </button>
    );
  }),
);

TreeItemButton.displayName = 'TreeItemButton';
